(function () {
  'use strict';

  /* @ngdoc object
   * @name exports.edit
   * @description
   *
   */
  angular
    .module('fertilization.nutrientComparisonExports.edit', [
      'ui.router'
    ]);
}());
